import React, { useEffect } from "react";
import ReactList, {
  ReactListEmpty,
  ReactListInitialLoader,
  ReactListItems,
  ReactListLoader,
  ReactListPagination,
  ReactListProvider,
  ReactListSearch,
} from "components/react-list/src";

import { CLIENT_FILTER } from "components/client/constants";
import { EmptySection1 } from "components/empty";
import { EvtClientCard } from "components/client/display-card";
import { EvtClientPlaceholderCard } from "components/client/placeholder";
import EvtSheet from "components/sheet";
import Search from "components/list/search";
import { Shimmer } from "components/shimmer";
import { fetchListData } from "components/client/api";
import { useState } from "react";

const attrs = ["id", "first_name", "last_name", "email", "company_id.name"];

const ClientInput = ({ onChange, value, disabled = false, label }) => {
  const [open, setOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    setSelectedClient(value);
  }, [value]);

  function handleSelectEmployee(client) {
    setSelectedClient(client);
    onChange?.(client);
    setOpen(false);
  }

  return (
    <div className="flex flex-col gap-1">
      {label && <label className="font-medium">{label}</label>}
      <EvtSheet
        setOpen={setOpen}
        open={open}
        title="Select Client"
        trigger={
          selectedClient ? (
            <EvtClientCard user={selectedClient} disabled={disabled} />
          ) : (
            <EvtClientPlaceholderCard />
          )
        }
      >
        <ReactListProvider config={{ requestHandler: fetchListData }}>
          <ReactList
            filters={CLIENT_FILTER}
            perPage={10}
            sortBy="name"
            sortOrder="asc"
            enableStateManager={true} // Enable state persistence (default: true)
            version={"client"}
            attrs={attrs}
          >
            <ReactListSearch>
              {(props) => (
                <Search {...props} searchPlaceholder={"Search"} fluid={true} />
              )}
            </ReactListSearch>
            <div className="mb-3 mt-6 ">
              <span className="text-muted-foreground text-sm">
                Search Results:
              </span>
            </div>
            <div className="overflow-y-auto flex-1 mt-6 pb-20">
              <ReactListInitialLoader>
                {() => {
                  return (
                    <div className="space-y-3">
                      {Array.from({ length: 8 }).map((_, index) => (
                        <Shimmer key={index} className={"w-full h-32"} />
                      ))}
                    </div>
                  );
                }}
              </ReactListInitialLoader>
              <ReactListEmpty>
                <EmptySection1 />
              </ReactListEmpty>

              <ReactListItems>
                {({ items }) => {
                  return (
                    <div className="space-y-3">
                      {items.map((user) => (
                        <EvtClientCard
                          user={user}
                          selected={selectedClient}
                          onClick={() => handleSelectEmployee(user)}
                        />
                      ))}
                    </div>
                  );
                }}
              </ReactListItems>
            </div>
          </ReactList>
        </ReactListProvider>
      </EvtSheet>
    </div>
  );
};

export default React.memo(ClientInput);
